import type { Progress } from '@openeducation/oe-rn-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class ProgressDao {
  static async getProgress(env: Environment, personId: number) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.get<Progress>(`${url}/progress/${personId}`);
    return data;
  }
}
